import React from "react";
import { FormControl, FormLabel, Input, Switch, Textarea, VStack } from "@chakra-ui/react";

const RiskReviewSectionEditor = ({ section, onChange, isReadOnly }) => (
  <VStack align="stretch" spacing={3}>
    <FormControl>
      <FormLabel>Section Name</FormLabel>
      <Input value={section?.name || ""} isReadOnly={isReadOnly} onChange={(event) => onChange?.("name", event.target.value)} />
    </FormControl>
    <FormControl>
      <FormLabel>Section Code</FormLabel>
      <Input value={section?.code || ""} isReadOnly={isReadOnly} onChange={(event) => onChange?.("code", event.target.value)} />
    </FormControl>
    <FormControl>
      <FormLabel>Description</FormLabel>
      <Textarea value={section?.description || ""} isReadOnly={isReadOnly} onChange={(event) => onChange?.("description", event.target.value)} />
    </FormControl>
    <Switch isChecked={section?.collapsible !== false} isDisabled={isReadOnly} onChange={(event) => onChange?.("collapsible", event.target.checked)}>
      Collapsible
    </Switch>
    <Switch isChecked={section?.defaultExpanded !== false} isDisabled={isReadOnly} onChange={(event) => onChange?.("defaultExpanded", event.target.checked)}>
      Default Expanded
    </Switch>
    <Switch isChecked={Boolean(section?.required)} isDisabled={isReadOnly} onChange={(event) => onChange?.("required", event.target.checked)}>
      Required
    </Switch>
  </VStack>
);

export default RiskReviewSectionEditor;
